module.exports = __webpack_public_path__ + "static/media/pinkmask.f01e6f95.svg";